import React from 'react';
import './Notification.css';

function Notification({ message, onClose }) {
  return (
    <div className="notification-popup">
      <div className="notification-content">
        {message}
      </div>
    </div>
  );
}

export default Notification;

